import { getApplications, addApplication, updateApplication, deleteApplication, getStats, STATUSES } from '../applicationTracker.js';

function statusBadge(status) {
    const s = STATUSES.find(st => st.value === status) || { label: status, color: '#6b7280' };
    return `<span style="background:${s.color}15;color:${s.color};border:1px solid ${s.color}40;padding:0.15rem 0.5rem;border-radius:9999px;font-size:0.7rem;font-weight:600;">${s.label}</span>`;
}

function statusOptions(current) {
    return STATUSES.map(s => `<option value="${s.value}" ${s.value === current ? 'selected' : ''}>${s.label}</option>`).join('');
}

function renderStats() {
    const apps = getApplications();
    const stats = getStats(apps);
    document.getElementById('totalApps').textContent = stats.total;
    document.getElementById('followUpCount').textContent = stats.needsFollowUp;

    const countsHtml = STATUSES.map(s => {
        const count = stats.statusCounts[s.value] || 0;
        if (count === 0) return '';
        return `<span style="font-size:0.75rem;color:${s.color};font-weight:600;">${s.label}: ${count}</span>`;
    }).filter(Boolean).join(' · ');

    document.getElementById('statusBreakdown').innerHTML = countsHtml || '<span style="color:#6b7280;font-size:0.75rem;">No applications yet</span>';
}

function renderTable() {
    const apps = getApplications();
    const tbody = document.getElementById('appTableBody');

    if (apps.length === 0) {
        tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;color:#6b7280;padding:2rem;">No applications tracked yet. Add your first one above!</td></tr>';
        return;
    }

    tbody.innerHTML = apps.map(app => `
        <tr data-id="${app.id}">
            <td><strong>${app.company || '—'}</strong></td>
            <td>${app.role || '—'}</td>
            <td>${statusBadge(app.status)}</td>
            <td>${app.dateApplied || '—'}</td>
            <td>${app.followUpDate || '—'}</td>
            <td>
                <select class="status-select" data-id="${app.id}" style="font-size:0.75rem;padding:0.2rem;border:1px solid #d1d5db;border-radius:4px;">
                    ${statusOptions(app.status)}
                </select>
                <button class="delete-btn" data-id="${app.id}" style="color:#ef4444;background:none;border:none;cursor:pointer;font-weight:700;font-size:0.75rem;margin-left:0.5rem;">Delete</button>
            </td>
        </tr>
    `).join('');

    renderStats();
}

function handleAdd() {
    const app = {
        company: document.getElementById('addCompany').value,
        role: document.getElementById('addRole').value,
        status: document.getElementById('addStatus').value,
        dateApplied: document.getElementById('addDate').value,
        followUpDate: document.getElementById('addFollowUp').value,
        notes: document.getElementById('addNotes').value
    };

    if (!app.company) return;

    addApplication(app);

    // Reset form
    document.getElementById('addCompany').value = '';
    document.getElementById('addRole').value = '';
    document.getElementById('addStatus').value = 'applied';
    document.getElementById('addDate').value = new Date().toISOString().split('T')[0];
    document.getElementById('addFollowUp').value = '';
    document.getElementById('addNotes').value = '';

    renderTable();
}

// Event delegation
document.getElementById('appTableBody').addEventListener('change', (e) => {
    if (e.target.classList.contains('status-select')) {
        updateApplication(e.target.getAttribute('data-id'), { status: e.target.value });
        renderTable();
    }
});

document.getElementById('appTableBody').addEventListener('click', (e) => {
    if (e.target.classList.contains('delete-btn')) {
        if (confirm('Delete this application?')) {
            deleteApplication(e.target.getAttribute('data-id'));
            renderTable();
        }
    }
});

document.getElementById('addBtn').addEventListener('click', handleAdd);
document.getElementById('addDate').value = new Date().toISOString().split('T')[0];

// Export to CSV
document.getElementById('exportBtn').addEventListener('click', () => {
    const apps = getApplications();
    if (apps.length === 0) return;
    const headers = ['Company', 'Role', 'Status', 'Date Applied', 'Follow Up', 'Notes'];
    const rows = apps.map(a => [a.company, a.role, a.status, a.dateApplied, a.followUpDate, a.notes].map(v => `"${(v || '').replace(/"/g, '""')}"`).join(','));
    const csv = [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'job-applications.csv';
    a.click();
});

renderTable();
